const serverUrl = `${process.env.VUE_APP_SERVERURL}`;
const relevateUrl = `${process.env.VUE_APP_RELEVATE_URL}`;
const worbixServerUrl = `${process.env.VUE_APP_WORBIXURL}`;
const slsServerUrl = `${process.env.VUE_APP_SLS_URL}`;
const uiHostUrl = `${process.env.VUE_APP_UIHOSTURL}`;
const commonServiceUrl = `${process.env.VUE_APP_COMMONSERVICEURL}`;
const adminEmail = `${process.env.VUE_APP_ADMIN_EMAIL}`;
const customerUrl = `${process.env.VUE_APP_CUSTOMERURL}`;
const paymentSecretKey = `${process.env.VUE_APP_PAYMENT_KEY}`;
const stripePk = `${process.env.VUE_APP_STRIPE_PK}`;
const appEnv = `${process.env.VUE_APP_ENV}`;
const invitationLink = `${process.env.VUE_APP_INVITATION_LINK}`;
const fakeBrokerageEmail = `${process.env.VUE_APP_ALLOWED_EMAIL_ID}`;
const demoPersonId = `${process.env.VUE_APP_DEMO_AGENT}`;
const demoNRDS = 'demo'
// console.log('env', process.env);
export {
    serverUrl,
    uiHostUrl,
    relevateUrl,
    customerUrl,
	paymentSecretKey,
	worbixServerUrl,
	stripePk,
    demoNRDS,
    slsServerUrl,
    adminEmail,
    commonServiceUrl,
    appEnv,
    demoPersonId,
    fakeBrokerageEmail,
    invitationLink
}
